import { Navigate, createBrowserRouter } from "react-router-dom";
import Layout from "../layouts";
import Home from "../pages/home";
import Contact from "../pages/contact";
import Advertisers from "../pages/advertisers";
import Publishers from "../pages/publishers";
import Agreement from "../pages/agreement";
import Optout from "../pages/opt-out";
import KVKK from "../pages/kvkk";
import PrivacyPolicyAndCookieUsage from "../pages/privacy-policy-and-cookie-usage";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        handle: {
            breadcrumbs: [
                {
                    label: "Home",
                    link: "/",
                },
            ],
        },
        children: [
            {
                index: true,
                element: <Home />,
                handle: {
                    breadcrumbs: [
                        {
                            label: "Home",
                            link: "/",
                        },
                    ],
                },
            },
            {
                path: "contact",
                element: <Contact />,
                handle: {
                    breadcrumbs: [
                        {
                            label: "Home",
                            link: "/",
                        },
                        {
                            label: "Contact",
                            link: "/contact",
                        },
                    ],
                },
            },
            {
                path: "advertisers",
                element: <Advertisers />,
                handle: {
                    breadcrumbs: [
                        {
                            label: "Home",
                            link: "/",
                        },
                        {
                            label: "Advertisers",
                            link: "/advertisers",
                        },
                    ],
                },
            },
            {
                path: "publishers",
                element: <Publishers />,
                handle: {
                    breadcrumbs: [
                        {
                            label: "Home",
                            link: "/",
                        },
                        {
                            label: "Publishers",
                            link: "/publishers",
                        },
                    ],
                },
            },
            {
                path: "user-agreement",
                element: <Agreement />,
                handle: {
                    breadcrumbs: [
                        {
                            label: "Home",
                            link: "/",
                        },
                        {
                            label: "User Agreement",
                            link: "/user-agreement",
                        },
                    ],
                },
            },
            {
                path: "opt-out",
                element: <Optout />,
                handle: {
                    breadcrumbs: [
                        {
                            label: "Home",
                            link: "/",
                        },
                        {
                            label: "Opt-Out",
                            link: "/opt-out",
                        },
                    ],
                },
            },
            {
                path: "kvkk",
                element: <KVKK />,
                handle: {
                    breadcrumbs: [
                        {
                            label: "Home",
                            link: "/",
                        },
                        {
                            label: "KVKK (Personal Data Protection Law) Information Text",
                            link: "/kvkk",
                        },
                    ],
                },
            },
            {
                path: "privacy-policy-and-cookie-usage",
                element: <PrivacyPolicyAndCookieUsage />,
                handle: {
                    breadcrumbs: [
                        {
                            label: "Home",
                            link: "/",
                        },
                        {
                            label: "Privacy Policy and Cookie Usage",
                            link: "/privacy-policy-and-cookie-usage",
                        },
                    ],
                },
            },
            {
                path: "*",
                element: <Navigate to="/" />,
                handle: {
                    breadcrumbs: [
                        {
                            label: "Home",
                            link: "/",
                        },
                    ],
                },
            },
        ],
    },
]);

export default router;